var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CloseOutlined } from 'msb-icons-svg/lib/src';
import classNames from 'classnames';
import RcDrawer from 'rc-drawer';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import { NoFormStyle } from '../form/context';
import { getTransitionName } from '../_util/motion';
import { tuple } from '../_util/type';
import warning from '../_util/warning';
const SizeTypes = tuple('small', 'medium', 'large', 'extra-large');
// msb overwrite start
const sizeSmall = '40%';
const sizeMedium = '60%';
const sizeLarge = '80%';
const sizeExtraLarge = '100%';
const mergedSize = (size) => {
    switch (size) {
        case 'small': {
            return sizeSmall;
        }
        case 'medium': {
            return sizeMedium;
        }
        case 'large': {
            return sizeLarge;
        }
        case 'extra-large': {
            return sizeExtraLarge;
        }
        default: {
            return sizeSmall;
        }
    }
};
const defaultPushState = { distance: 180 };
function BottomSheet(props) {
    const { height, size = 'small', closable = true, mask = true, push = defaultPushState, closeIcon = React.createElement(CloseOutlined, null), bodyStyle, drawerStyle, className, visible, open, children, style, title, headerStyle, onClose, footer, footerStyle, prefixCls: customizePrefixCls, getContainer: customizeGetContainer, iconLeft, afterVisibleChange, afterOpenChange } = props, rest = __rest(props, ["height", "size", "closable", "mask", "push", "closeIcon", "bodyStyle", "drawerStyle", "className", "visible", "open", "children", "style", "title", "headerStyle", "onClose", "footer", "footerStyle", "prefixCls", "getContainer", "iconLeft", "afterVisibleChange", "afterOpenChange"]);
    const { getPopupContainer, getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('bottom-sheet', customizePrefixCls);
    const getContainer = 
    // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer
        ? () => getPopupContainer(document.body)
        : customizeGetContainer;
    const closeIconNode = closable && (React.createElement("button", { type: "button", onClick: onClose, "aria-label": "Close", className: `${prefixCls}-close` }, closeIcon));
    [
        ['visible', 'open'],
        ['afterVisibleChange', 'afterOpenChange'],
    ].forEach(([deprecatedName, newName]) => {
        warning(!(deprecatedName in props), 'Drawer', `\`${deprecatedName}\` is deprecated which will be removed in next major version, please use \`${newName}\` instead.`);
    });
    function renderHeader() {
        if (!title && !closable) {
            return null;
        }
        return (React.createElement("div", { className: classNames(`${prefixCls}-header`, {
                [`${prefixCls}-header-close-only`]: closable && !title && !iconLeft,
            }), style: headerStyle },
            iconLeft && React.createElement("div", { className: `${prefixCls}-icon-left` }, iconLeft),
            React.createElement("div", { className: `${prefixCls}-header-title` }, title && React.createElement("div", { className: `${prefixCls}-title` }, title)),
            closeIconNode));
    }
    function renderFooter() {
        if (!footer) {
            return null;
        }
        const footerClassName = `${prefixCls}-footer`;
        return (React.createElement("div", { className: footerClassName, style: footerStyle }, footer));
    }
    const drawerClassName = classNames({
        'no-mask': !mask,
        [`${prefixCls}-rtl`]: direction === 'rtl',
    }, className);
    // ============================ Size ============================
    // msb overwrite start
    const mergedHeight = React.useMemo(() => height !== null && height !== void 0 ? height : mergedSize(size), [height, size]);
    // msb overwrite end
    // =========================== Motion ===========================
    const maskMotion = {
        motionName: getTransitionName(prefixCls, 'mask-motion'),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500,
    };
    const panelMotion = motionPlacement => ({
        motionName: getTransitionName(prefixCls, `panel-motion-${motionPlacement}`),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500,
    });
    // =========================== Render ===========================
    return (React.createElement(NoFormStyle, { status: true, override: true },
        React.createElement(RcDrawer, Object.assign({ prefixCls: prefixCls, onClose: onClose }, rest, { open: open || visible, mask: mask, push: push, height: mergedHeight, rootClassName: drawerClassName, getContainer: getContainer, afterOpenChange: isOpen => {
                afterOpenChange === null || afterOpenChange === void 0 ? void 0 : afterOpenChange(isOpen);
                afterVisibleChange === null || afterVisibleChange === void 0 ? void 0 : afterVisibleChange(isOpen);
            }, maskMotion: maskMotion, motion: panelMotion, rootStyle: style, placement: "bottom" }),
            React.createElement("div", { className: `${prefixCls}-wrapper-body`, style: Object.assign({}, drawerStyle) },
                React.createElement("div", { className: `${prefixCls}-indicator` }),
                renderHeader(),
                React.createElement("div", { className: `${prefixCls}-body`, style: bodyStyle }, children),
                renderFooter()))));
}
if (process.env.NODE_ENV !== 'production') {
    BottomSheet.displayName = 'MenuList';
}
export default BottomSheet;
